export default "__VITE_ASSET__8E1SMqGJ__"